export default __webpack_public_path__ + "static/media/Edit.bf0ec933.svg";